import { useDisclosure as useMantineDisclosure } from '@mantine/hooks';

export const useDisclosure = useMantineDisclosure;
